export default {
  showMainLayout: true,
  sidebarToHover: false,
  loadingComponents: [],
  // расширенная палитра цветов из design.ini (designSettings.colors)
  colors: {},
};
